<!-- App upload,file Upload,Maintenance,Navigation -->
<div class="col-12 col-md-12 mt-2 mb-2">
  <div class="row">
    <div class="col-md-6 col-6">
      <!-- App Upload -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #f07272;"></i>&nbsp;{{"App Upload" | translate}}
              <button [disabled]="!this.showinstallation || appInstalling" (click)="clearapk()"
                class="btn btn-sm btn-danger pull-right ng-isolate-scope"
                style="position: relative; top: -0.6em; margin-right: 20px; "><i
                  class="fa fa-regular fa-trash-o reset-icon"></i>&nbsp;{{"Clear" | translate}}</button>
            </div>
            <div class="widget-content drop-container" style="width: 100%;" [title]="this.titleAppupld"
              [class.disabled-upload]="appInstalling">

              <label id="file-upload" class="drop-area file-input btn-file ng-isolate-scope"
                [class.disabled]="appInstalling">
                <input #appInstall type="file" id="file-upload" accept=".apk,.ipa" (click)="resetInputAppInstall()"
                  (input)="appUploadToDevice($event)" class="ng-isolate-scope" style="display: none;"
                  [disabled]="appInstalling">
                <i class="fa fa-2x fa-upload drop-area-icon" [style.cursor]="appInstalling ? 'not-allowed' : 'pointer'"
                  [style.opacity]="appInstalling ? '0.5' : '1'"></i>
                <div class="drop-area-text">
                  <span [style.cursor]="appInstalling ? 'not-allowed' : 'pointer'"
                    [style.opacity]="appInstalling ? '0.5' : '1'">
                    {{appInstalling ? ("Upload in progress..." | translate) : ("Drop file to upload" | translate)}}
                  </span>
                </div>
              </label>
            </div>

            @if (appInstalling) {
                <div class="modern-progress-container">
                  <!-- App Info Header -->
                  <div class="app-info-header">
                    <div class="app-icon-wrapper">
                      <i class="fa fa-android app-icon-android"></i>
                    </div>
                    <div class="app-info-text">
                      <span class="app-file-name">{{ titleAppupld || 'application.apk' }}</span>
                      <span class="app-file-status">
                        {{ (errorAppUpload ? "Installation failed" : (successAppUpload ? "Successfully installed" :
                        (progressAppUpload < 50 ? "Uploading to server..." : "Installing on device..." ))) | translate
                          }} </span>
                    </div>
                  </div>

                  <!-- Progress Bar -->
                  <div class="modern-progress-header">
                    <span class="stage-label">
                      @if (!successAppUpload && !errorAppUpload) {
                        <i class="fa fa-circle-o-notch fa-spin pulse-icon"></i>
                      }
                      @if (successAppUpload) {
                        <i class="fa fa-check-circle stage-installed"></i>
                      }
                      @if (errorAppUpload) {
                        <i class="fa fa-exclamation-circle stage-error"></i>
                      }
                      {{ (errorAppUpload ? "Failed" : (successAppUpload ? "Installed" : (progressAppUpload < 50
                        ? "Uploading" : "Installing" ))) | translate }} </span>
                        <span class="percent-label" [class.stage-installed]="successAppUpload"
                          [class.stage-error]="errorAppUpload">
                          {{ progressAppUpload }}%
                        </span>
                  </div>
                  <div class="modern-progress-track">
                    <div class="modern-progress-fill" [style.width.%]="progressAppUpload"
                      [class.success]="successAppUpload" [class.error]="errorAppUpload">
                    </div>
                  </div>
                </div>
            }

            @if (showinstallation) {
            <div class="panel panel-default panel-open">
              <div class="panel-heading" ng-keypress="toggleOpen($event)" style="color: #333;
                  background-color: #f5f5f5; border-color: #ddd;">
                <h4 class="panel-title">
                  <a tabindex="0" class="accordion-toggle" (click)="toggleOpen()" style="  font-weight: 300;
                     padding: 8px 15px 10px;
                        display: block;" uib-accordion-transclude="heading">
                    <span ng-class="{'text-muted': isDisabled}" class="ng-binding">
                      <i class="fa fa-file-o ng-scope"> </i>
                      <span class="ng-binding ng-scope"> {{manifest.package}}</span>
                      <button (click)="uninstall(manifest.package)" ng-show="installation.success"
                        style="margin: -0.5em -1.2em 0 0;" class="btn btn-xs btn-danger pull-right ng-scope"><i
                          class="fa fa-trash-o"></i><span>
                          <span class="ng-scope">{{"Uninstall" | translate}}</span>
                        </span>
                      </button>
                    </span>
                  </a>
                </h4>
              </div>
              @if (isPanelOpen) {
              <div>
                <form>
                  <table class="table table-condensed">
                    <tbody>
                      <tr>
                        <td translate>{{"Package" | translate}}</td>
                        <td>
                          <input class="form-control" type="text" [value]="selectedPackageName">
                        </td>
                      </tr>
                      <tr>
                        <td translate>{{"Activity" | translate}}</td>
                        <td>
                          <input class="form-control" type="text" placeholder="" [value]="activityValue"
                            (focus)="onInputFocusActivity()" (blur)="onBlur()">
                          <div class="dropdown">
                            @if (showDropdownactivity) {
                            <ul class="activity">
                              @for ( activity of activities; track activity) {
                              <li (click)="onItemSelectactivity(activity.name)">
                                {{activity.name}}
                              </li>
                              }
                            </ul>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td translate>{{"Action" | translate}}</td>
                        <td>
                          <input class="form-control" type="text" placeholder="" [value]="actionsValue"
                            (focus)="onInputFocusActions()" (blur)="onBlur()">
                          <div class="dropdown">
                            @if (showDropdownactions) {
                            <ul class="activity">
                              @for ( action of actions; track action) {
                              <li (click)="onItemSelectactions(action.name)">
                                {{action.name}}
                              </li>
                              }
                            </ul>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td translate>{{"Category" | translate}}</td>
                        <td>
                          <input class="form-control" type="text" placeholder="" [value]="categoryValue"
                            (focus)="onInputFocusCategory()" (blur)="onBlur()">
                          <div class="dropdown">
                            @if (showDropdowncategory) {
                            <ul class="activity">
                              @for ( cate of category; track cate) {
                              <li (click)="onItemSelectcategory(cate.name)">
                                {{cate.name}}
                              </li>
                              }
                            </ul>
                            }
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td translate>{{"Data" | translate}}</td>
                        <td>
                          <input class="form-control" type="text" placeholder="" [value]="dataValue"
                            (focus)="onInputFocusData()" (blur)="onBlur()">
                          <div class="dropdown">
                            @if (showDropdowndata) {
                            <ul class="activity">
                              @for ( da of Data; track da) {
                              <li (click)="onItemSelectdata(da.scheme)">
                                {{da.scheme}}
                              </li>
                              }
                            </ul>
                            }
                          </div>
                        </td>
                    </tbody>
                  </table>
                  <button class="btn btn-sm btn-primary pull-right" (click)="runActivity()">
                    <i class="fa fa-play"></i>
                    <span translate> Launch Activity</span>
                  </button>
                </form>
              </div>
              }
              @if (isPanelOpen) {
              <button class="btn btn-sm btn-primary" (click)="openManifest()" uib-btn-checkbox>
                <i class="fa fa-list"></i>
                <span> {{this.manifestShow?'Hide':'Show'}} Manifest</span>
              </button>
              }
              @if (this.manifestShow) {
              <pre class="shellWindow manifest-text">{{ this.manifestData | json }}</pre>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <!-- file upload  -->
      @if (device.platform !='iOS') {
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #2f9e00; margin-bottom: 13px;"></i>&nbsp;{{"File
              Upload" | translate}}
              <button [disabled]="!uploadSuccess || isUploading" (click)="clearFileUpload()"
                class="btn btn-sm btn-danger pull-right ng-isolate-scope"
                style="position: relative; top: -0.6em; margin-right: 20px;">
                <i class="fa fa-regular fa-trash-o reset-icon"></i>&nbsp;{{"Clear" | translate}}
              </button>
            </div>
            @if (isUploading) {
            <div class="progress">
              <div class="progress-bar" role="progressbar" [style.width.%]="progressFileUpload"
                [attr.aria-valuenow]="progressFileUpload" aria-valuemin="0" aria-valuemax="100">
                {{ "Uploading" + progressFileUpload | translate}}%
              </div>
            </div>
            }
            <!-- for success -->
            @if (uploadSuccess && this.progressFileUpload>90) {
            <div class="upload-success-message"
              style="background: linear-gradient(135deg, #4CAF50, #45a049);color: white;padding: 12px 16px;border-radius: 8px;margin: 10px 0;display: flex;align-items: center;animation: slideIn 0.3s ease-in-out;box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);">
              <i class="fa fa-check-circle" style="margin-right: 8px; font-size: 18px;"></i>
              <span style="font-weight: 500;">{{ uploadMessage }}</span>
            </div>
            }
            <!-- for failure -->
            @if (!uploadSuccess && this.progressFileUpload==90 && !apiCalled) {
            <div class="upload-success-message"
              style="background: linear-gradient(135deg, #af4c4c, #df3838);color: white;padding: 12px 16px;border-radius: 8px;margin: 10px 0;display: flex;align-items: center;animation: slideIn 0.3s ease-in-out;box-shadow: 0 4px 8px rgba(76, 175, 80, 0.3);">
              <i class="fa fa-check-circle" style="margin-right: 8px; font-size: 18px;"></i>
              <span style="font-weight: 500;">{{ uploadMessage }}</span>
            </div>
            }
            <div class="widget-content drop-container" [title]="this.titleFileUpld">
              <label for="file" class="drop-area file-input btn-file ng-isolate-scope"
                [style.pointer-events]="isUploading ? 'none' : 'auto'" [style.opacity]="isUploading ? '0.6' : '1'">
                <input #fileUpload type="file" id="file" (click)="resetInputFileUpload()"
                  (input)="fileUploadToDevice($event)" ng-file-select="fileUploadToDevice($event.target)"
                  class="ng-isolate-scope" style="display: none;" [disabled]="isUploading">
                <i class="fa fa-2x fa-upload drop-area-icon"
                  [style.color]="uploadSuccess ? '#4CAF50' : (isUploading ? '#6c757d' : '')"
                  style="cursor: pointer; transition: color 0.3s ease;"></i>
                <div class="drop-area-text">
                  <span style="cursor: pointer;" [style.color]="isUploading ? '#6c757d' : ''">
                    {{ isUploading ? 'Uploading...' : ("Drop file to upload" | translate) }}
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Shortcut Buttons Section -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #ae00ff;"></i>&nbsp;<span>{{"Apps" |
                translate}}</span>
              <div class="row">
                <div class="col">
                  <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="openSettings()">
                    <i class="fa fa-solid fa-gear fa-lg" style="color: #919191;"></i>
                    <div class="icon-title">{{"Settings" | translate}}</div>
                  </button>
                  <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="control.openStore()">
                    <i class="fa fa-solid fa-shopping-cart fa-lg" style="color: #337eff;"></i>
                    <div class="icon-title">{{"App Store" | translate}}</div>
                  </button>
                  <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="onLanguageButtonClick()">
                    <i class="fa fa-solid fa-globe fa-lg" style="color: #00bcd4;"></i>
                    <div class="icon-title">{{ "Language" | translate }}</div>
                  </button>
                  @if (showLangList) {
                  <div class="language-list">
                    <input type="text" placeholder="Search language..." [(ngModel)]="searchText" class="lang-search" />
                    <ul class="language-scrollable">
                      @for (langCode of filteredLanguages(); track langCode) {
                      <li (click)="selectLanguage(langCode)">
                        • {{ languageMap[langCode] || langCode }}
                        @if (selectedLangCode === langCode) {
                        <span class="checkmark">✔</span>
                        }
                      </li>
                      }
                    </ul>
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <!-- ios change  -->
                @if (!device.ios) {
                <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="openWiFiSettings()"
                  ng-if='!device.plaform=="iOS"'>
                  <i class="fa fa-solid fa-wifi fa-lg" style="color: #75a8ff;"></i>
                  <div class="icon-title">{{"Wifi" | translate}}</div>
                </button>
                }
                <!-- ios change  -->
                @if (!device.ios) {
                <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="openManageApps()">
                  <i class="fa fa-solid fa-list fa-lg" style="color: #ff9500;"></i>
                  <div class="icon-title">{{"Manage Apps" | translate}}</div>
                </button>
                }
                <!-- ios change  -->
                @if (!device.ios) {
                <button class="col-md-4 col-4 btn btn-primary-outline icon-app" (click)="openDeveloperSettings()">
                  <i class="fa fa-solid fa-sliders fa-lg" style="color: #3ba800;"></i>
                  <div class="icon-title">{{"Developer" | translate}}</div>
                </button>
                }
                <!-- ios change  -->
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <!-- Advanced Input -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #b81fff;"></i>&nbsp;{{"Advanced Input" | translate}}
            </div>
            <div class="widget-content padded">
              <div>
                <!-- <h6 class="text-secondary">{{"Navigation Buttons" | translate}}</h6>
            <div class="navbarbutton">
              <div class="controls as-cell" style="align-items: flex-end;">
                ios change
                [ngClass]="{'disabled': device.ios}" for menu
                <div class="btn-group btn-group-justified" style="width: 100%;"
                  ng-if='!device.platform=="iOS"'>
                  <a device-control-key="menu" title="Menu" (click)="key('menu')"
                    class="btn btn-primary  no-transition">
                    <i class="fa fa-bars"></i>
                  </a>
                  <a (click)="key('home')" device-control-key="home" title="Home"
                    class="btn btn-primary  no-transition">
                    <i class="fa fa-home"></i>
                  </a>
                  <a device-control-key="app_switch" (click)="key('app_switch')" title="App switch"
                    [ngClass]="{'disabled': device.ios}" class="btn btn-primary  no-transition">
                    <i class="fa fa-square-o"></i>
                  </a>
                  <a device-control-key="back" (click)="key('back')" title="Back"
                    [ngClass]="{'disabled': device.ios}" class="btn btn-primary  no-transition">
                    <i class="fa fa-mail-reply"></i>
                  </a>
                </div>
                ios change
              </div>
            </div>
            <h6 class="text-secondary">{{"Special Keys" | translate}}</h6>
            <div class="special-keys-buttons">
              <button title="Lock" (click)="press('power')" class="btn btn-primary btn-xs">
                <i class="fa fa-lock"></i>
              </button>
              <button *ngIf="!device.ios" title="Unlock" (click)="press('menu')"
                class="btn btn-primary btn-xs">
                <i class="fa fa-unlock"></i>
              </button>
              <button title="Camera" (click)="press('camera')" class="btn btn-primary btn-xs">
                <i class="fa fa-camera"></i>
              </button>
              <button title="Search" (click)="press('search')" class="btn btn-primary btn-xs">
                <i class="fa fa-search"></i>
              </button>
              <button title="Refresh" (click)="refresh()" *ngIf="device.platform == 'iOS'"
                class="btn btn-primary btn-xs">
                <i class="fa fa-refresh"></i>
              </button>
            </div> -->

                <h6 class="text-secondary">{{"Volume" | translate}}</h6>
                <div class="btn-group volume-button-group">
                  @if (!device.ios) {
                  <button title="Mute" (click)="press('volume_mute')" class="btn btn-primary btn-xs"
                    style="font-size: 12.5px;">
                    <i class="fa-solid fa-volume-xmark"></i> <!-- Larger icon size -->
                  </button>
                  }
                  <button title="Volume Down" (click)="press('volume_down')" class="btn btn-primary btn-xs">
                    <i class="fa fa-volume-down"></i> <!-- Larger icon size -->
                  </button>
                  <button title="Volume Up" (click)="press('volume_up')" class="btn btn-primary btn-xs">
                    <i class="fa fa-volume-up"></i> <!-- Larger icon size -->
                  </button>
                </div>

                @if (device.platform === 'Android') {
                <h6 class="text-secondary">{{"Media" | translate}}</h6>
                }
                @if (device.platform === 'Android') {
                <div class="btn-group">
                  <!-- ios change  -->
                  <button title="Previous" (click)="press('media_previous')" class="btn btn-primary btn-xs">
                    <i class="fa fa-step-backward"></i>
                  </button>
                  <button title="Play/Pause" (click)="press('media_play_pause')" class="btn btn-primary btn-xs">
                    <i class="fa fa-play"></i>
                  </button>
                  <button title="Next" (click)="press('media_next')" class="btn btn-primary btn-xs">
                    <i class="fa fa-step-forward"></i>
                  </button>
                  <!-- ios change  -->
                </div>
                }
              </div>
              <!-- navbar buttons -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-6">
      <!-- Maintenance -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #707070;"></i>&nbsp; {{"Maintainance" | translate}}
            </div>
            <div class="widget-content padded">
              <button (click)="rebootDeviceTemplate(device_restart_template,$event)" class="btn btn-sm btn-danger">
                <i class="fa fa-refresh"></i>&nbsp; {{"Restart Device" | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Navigation Section -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #1f71ff;"></i>&nbsp;{{"Navigation" | translate}}
              <!-- ios change  -->
              <button class="btn btn-danger btn-sm border-0 ml-auto reset-button" (click)="clearSettings()"
                ng-disabled="device.platform=='iOS'" title="Reset all browser settings" [disabled]="!textURL">
                <i class="fa fa-regular fa-trash-o reset-icon"></i>&nbsp;{{"Reset" | translate}}
              </button>
              <!-- ios change  -->
            </div>
            <div class="widget-content padded">
              <!-- ios change  -->
              <form enable-autofill method="post" target="_autofill" action="/app/api/v1/dummy"
                ng-disabled='device.platform=="iOS" && device.version < 17'>
                <div class="input-group form-outline">
                  <input type="text" [(ngModel)]="textURL" name="textURL" placeholder="http://..." autocomplete="url"
                    text-focus-select autocapitalize="off" spellcheck="false" accesskey="N" tabindex="10"
                    style="border-radius: 7vh;" id="form12" class="form-control"
                    [disabled]="device?.platform === 'iOS' && device?.version < 17" />
                  <!-- <img [src]="urlFavicon"> -->
                  <div class="input-group-btn" style="margin-left: 1vh;">
                    <button class="btn btn-primary" style="border-radius: 30px;" (click)="openURL()">{{"Open" |
                      translate}}
                    </button>
                  </div>
                </div>
              </form>
              <!-- ios change  -->

              <!-- new -->
              @if (device.platform=='Android') {
              <div class="btn-group">
                <div class="btn-group browser-buttons" (click)="focusUrl = true">
                  <div class="btn-group browser-buttons">
                    @for (browserRadio of device.browser.apps; track trackByBrowserId($index, browserRadio)) {
                    <button style="border:none;border-radius: 7px;" class="btn btn-default"
                      (click)="onBrowserChange(browserRadio)" [class.active]="browser === browserRadio"
                      [title]="browserRadio.name + ' (' + browserRadio.developer + ')'">
                      @if (browserRadio.type) {
                      <img class="browser-icon" [src]="'assets/browsers/' + browserRadio.type + '.png'"
                        [alt]="browserRadio.name">
                      }
                    </button>
                    }
                  </div>
                </div>
              </div>
              }
              <!-- new -->
              <!-- <button class="btn btn-light browser-buttons" style="margin: 1vh;" title="Chrome (Google Inc.)">
          <img class="browser-icon pointer" src="assets/browsers/chrome.png" />
        </button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- Shell Section -->
      @if (!device.ios) {
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #9e9e9e;"></i>&nbsp;{{"Shell" | translate}}
              <a class="btn border-0 info-button" title="Executes remote shell commands"><i
                  class="fa fa-question-circle"></i></a>
              @if (!device.ios) {
              <button class="btn btn-sm btn-danger pull-right ng-isolate-scope"
                style="position: relative; top: -0.6em; margin-right: 20px;" (click)="clear()"
                [disabled]="!command && !data && !shellShow">
                <i class="fa fa-regular fa-trash-o reset-icon"></i>&nbsp;{{"Clear" | translate}}
              </button>
              }
            </div>
            <div class="widget-content padded">
              <form enable-autofill="enable-autofill" action="/app/api/v1/dummy">
                <div class="input-group form-inline">
                  <!-- ios change  -->
                  <input autocapitalize="off" spellcheck="false" [(ngModel)]="command" name="command" tabindex="30"
                    accesskey="S" autocomplete="on" style="border-radius: 7vh;" class="form-control shell-input"
                    [disabled]="device?.platform === 'iOS'">
                  <!-- ios change  -->
                  <span class="input-group-btn">
                    <!-- ios change  -->
                    <button class="btn btn-primary-outline" (click)="runShell()"
                      ng-disabled='!command || device.platform=="iOS"' class="btn btn-primary"
                      style="margin-left: 20px;">
                      <i class="fa fa-play"></i>
                    </button>
                    <!-- ios change  -->
                  </span>
                </div>
              </form>
              <!-- <div> -->
              @if (data && this.shellShow) {
              <pre class="shellWindow dropdown-menu show">{{data}}</pre>
              }
              <!-- <h1 class="shell-results selectable ng-binding">{{ data }}98767</h1> -->
              <!-- <h1 *ngIf="result.settled && !data" class="shell-results selectable shell-results-empty">No output</h1> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Upload File To Server -->
      <div class="card">
        <div class="card-body">
          <div class="widget-container fluid-height">
            <div class="heading">
              <i class="fa fa-solid fa-bookmark" style="color: #500075;"></i>&nbsp;{{"Upload File To Server" |
              translate}}
            </div>
            <div class="widget-content drop-container" [title]="this.titleUpldSrvr">
              <label id="file-upload" class="drop-area file-input btn-file">
                <input #filetoServer type="file" id="file-upload" (click)="resetInputFiletoServer()"
                  (change)="fileUploadToServer($event)" class="ng-isolate-scope" style="display: none;">
                <i class="fa fa-2x fa-upload drop-area-icon" style="cursor: pointer;"></i>
                <div class="drop-area-text">
                  <span style="cursor: pointer;">{{"Drop file to upload" | translate}}</span>
                </div>
              </label>
            </div>

            <div class="mt-3">
              <button class="btn btn-sm btn-outline-secondary" (click)="toggleFileHistory()">
                <i class="fa fa-history"></i>
                {{ showFileHistory ? 'Hide History' : 'Show History' }}
              </button>
            </div>

            @if (showFileHistory) {
            <div class="file-history mt-3">
              <div class="history-header">
                <h6>Uploaded Files History</h6>
              </div>
              <div class="file-list" style="max-height: 300px; overflow-y: auto;">
                @for (file of uploadedFiles; track file) {
                <div class="file-item"
                  style="cursor: pointer; padding: 8px; border-bottom: 1px solid #eee; display: flex; align-items: center;">
                  <div class="file-icon" style="margin-right: 10px;">
                    <i class="fa fa-file-o" style="font-size: 16px; color: #666;"></i>
                  </div>
                  <div class="file-info" style="flex: 1;">
                    <div class="file-name" style="font-weight: 500; font-size: 14px;">
                      {{ file.name }}
                    </div>
                  </div>
                  <div class="file-actions" style="display: flex; gap: 5px;">
                    <button class="btn btn-sm btn-outline-primary" (click)="copyFilePath(file, $event)"
                      title="Copy file path">
                      <i class="fa fa-copy"></i>
                    </button>
                    <!-- Changed from deleteFile to confirmDeleteFile -->
                    <button class="btn btn-sm btn-outline-danger" (click)="confirmDeleteFile(file, $event)"
                      title="Delete file">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                }
                @if (uploadedFiles.length === 0) {
                <div class="text-center text-muted py-3">
                  No files uploaded yet
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<ng-template #delete_file let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete this file?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="deleteFile()">
        {{"Yes, proceed" | translate}}
      </button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelFileDelete()">
        {{"No, Cancel" | translate}}
      </button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #lang_change_template let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">
      Are you sure you want to change the language to <b>{{ selectedLangCode }}</b>?<br>
      {{"The device will be unavailable for a moment." | translate}}
    </p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="confirmLangChange()">Yes, proceed</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelLangChange()">No, Cancel</button>
    </div>
  </div>
</ng-template>


<ng-template #device_restart_template let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">
      {{"Are you sure you want to reboot this device?" | translate}} <br>
      {{"The device will be unavailable for a moment." | translate}}
    </p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="reboot()">{{"Yes, proceed" | translate}}</button>
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" | translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #alertWithCountdownTemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{ msg | translate }}</p>
    @if (!showReconnectButton) {
    <p class="alert-message">
      {{ 'Reconnecting in' | translate }} {{ timer }} {{ 'seconds...' | translate }}
    </p>
    }

    @if (showReconnectButton) {
    <div class="alert-actions reconnect-container">
      <button class="btn btn-outline-primary nowrap-button" type="button" (click)="ok()">
        <i class="fa fa-refresh"></i>
        <span class="ms-1">{{ "Try to reconnect" | translate }}</span>
      </button>
      <button class="btn btn-outline-success nowrap-button" (click)="second()">
        <i class="fa fa-sitemap"></i>
        <span class="ms-1">{{ "Go to Device List" | translate }}</span>
      </button>
    </div>
    }
  </div>
</ng-template>